module.exports = __webpack_public_path__ + "img/c9ef548a0e3073bb00fb4e55cef7cfc6.png";